import { TemplateRef, OnInit } from '@angular/core';
import { CertificadosService } from '../../../services/certificados.service';
//import { Tipos_certificados } from '../../../models/tipos_certificados.model';
import { FormBuilder, FormArray } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
var Tipos_certificadosComponent = /** @class */ (function () {
    function Tipos_certificadosComponent(fb, dialog, _certService) {
        this.fb = fb;
        this.dialog = dialog;
        this._certService = _certService;
        ///public tipos_certificados: Tipos_certificados;
        this.rows = [];
        this.matcher = new FormService();
        this.tipos_cert = [];
        this.results = [];
        this.favCerts = [];
        this.CertProp = [];
        this.Certchecked = [];
        this.tiposCertError = true;
        this.listaFinal = [];
        this.certificados = [];
        this.listaRoles = [];
        this.form = this.fb.group({
            tipos_cert: [],
            favCerts: [],
        });
        // this.CertProp = [{rol: '', id_direcc: '', folio: '', certificados: ''}]
        if (!JSON.parse(localStorage.getItem("tipos_certificados"))) {
            localStorage.setItem("tipos_certificados", JSON.stringify([]));
            localStorage.setItem("tipos_certificados", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("tipos_certificados"));
        }
    }
    Tipos_certificadosComponent.prototype.ngOnInit = function () {
        this.get_tipos_cert();
        this.getCertificados();
    };
    Tipos_certificadosComponent.prototype.addCertControls = function () {
        var _this = this;
        var arr = this.tipos_cert.map(function (item) {
            return _this.fb.control(false);
        });
        return this.fb.array(arr);
    };
    Tipos_certificadosComponent.prototype.get_tipos_cert = function () {
        if (JSON.parse(localStorage.getItem("propiedades")).length > 0) {
            this.propiedades = JSON.parse(localStorage.getItem("propiedades"));
        }
        else {
            localStorage.setItem("propiedades", JSON.stringify([]));
            this.propiedades = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', direc_anexo: '', direc_anexo_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', valido: '', recordId: '' }];
        }
    };
    Object.defineProperty(Tipos_certificadosComponent.prototype, "CertArray", {
        get: function () {
            return this.form.favCerts;
        },
        enumerable: true,
        configurable: true
    });
    Tipos_certificadosComponent.prototype.addCertificado = function (propiedad, certificado) {
        console.log(propiedad);
        console.log(certificado);
        if (this.listaRoles.length == 0) {
            this.listaRoles.push({
                rol: propiedad.rol,
                certificados: [certificado.cert_id]
            });
        }
        else {
            var roleExiste = false;
            var certificadoExiste = false;
            for (var i = 0; i < this.listaRoles.length; i++) {
                if (this.listaRoles[i].rol == propiedad.rol) {
                    roleExiste = true;
                    certificadoExiste = false;
                    for (var x = 0; x < this.listaRoles[i].certificados.length; x++) {
                        if (this.listaRoles[i].certificados[x] == certificado.cert_id) {
                            certificadoExiste = true;
                            this.listaRoles[i].certificados.splice(x, 1);
                        }
                    }
                    if (!certificadoExiste) {
                        this.listaRoles[i].certificados.push(certificado.cert_id);
                    }
                }
            }
            if (!roleExiste) {
                this.listaRoles.push({
                    rol: propiedad.rol,
                    certificados: [certificado.cert_id]
                });
            }
        }
        console.log(this.listaRoles);
        localStorage.setItem("tipos_certificados", JSON.stringify(this.listaRoles));
    };
    Tipos_certificadosComponent.prototype.getCertificados = function () {
        var _this = this;
        this._certService.getTipo_cert().subscribe(function (response) {
            _this.listaFinal = response.lista;
            console.log(_this.listaFinal);
        }, function (error) {
            console.log(error);
        });
    };
    Tipos_certificadosComponent.prototype.checkTouched = function () {
        var flg = false;
        this.CertArray.controls.forEach(function (control) {
            if (control.touched) {
                flg = true;
            }
        });
        return flg;
    };
    Tipos_certificadosComponent.prototype.add_tipos_cert = function () {
        //console.log("AGREGAR")
        var _this = this;
        this.Certchecked = [];
        this.CertArray.controls.forEach(function (control, i) {
            if (control.value) {
                _this.Certchecked.push(_this.tipos_cert[i]);
            }
        });
        this.tiposCertError = this.Certchecked.length > 0 ? false : true;
    };
    Tipos_certificadosComponent.prototype.cleanData = function () {
        // this.tipos_certificados = {cod: '',tipo:'', cert_id: ''};
    };
    Tipos_certificadosComponent.prototype.delete_tipos_certificados = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipos_certificados", JSON.stringify(this.rows));
            }
        }
    };
    return Tipos_certificadosComponent;
}());
export { Tipos_certificadosComponent };
